import QRCode from 'react-qr-code'

type VCardQrCodeProps = {
    value: string
    size?: number
}

const VCardQrCode: React.FC<VCardQrCodeProps> = ({ value, size = 220 }) => {
    if (!value) return null

    return (
        <div
            className="p-3 bg-white rounded-xl shadow-sm flex items-center justify-center"
            style={{ width: size + 24, height: size + 24 }}
        >
            <QRCode value={value} size={size} />
        </div>
    )
}

export default VCardQrCode
